'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getList();
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.list = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/AppConfGroups/${id}`).then(res => {
        this.getList();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/list/list.controller.js